const API_BASE_URL = 'https://server.hugssam.com/company/';

export { API_BASE_URL };
